<template>
  <div class="section-container">
    <el-tabs class="tabs-container" type="border-card" v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane class="tab-pane" :label="$t('system.logManagement.loginLog')" name="sysLoginLog">
        <Table ref="statisticsRef" :params="statistics.params" :request="getStatistics" tooltip-effect="light">
          <el-table-column type="index" :label="$t('pages.indexNo')" width="60px" />
          <el-table-column prop="createTime" :label="$t('system.logManagement.operationTime')" />
          <el-table-column prop="userName" :label="$t('system.logManagement.user')" />
          <!-- <el-table-column prop="actionDesc" :label="$t('system.logManagement.operationType')" /> -->
          <el-table-column prop="userAction" :label="$t('system.logManagement.operationType')">
            <template #default="{row}">
              <span>{{userListMap[row.userAction]}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="loginSuccess" :label="$t('system.logManagement.loginResult')">
            <template #default="{row}">
              <span>{{row.loginSuccess ? $t('system.emaillist.success') : $t('system.emaillist.failure')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="loginDesc" :label="$t('system.logManagement.description')" />
          <el-table-column prop="loginComment" :label="$t('system.logManagement.remark')" />
          <el-table-column prop="operIp" :label="$t('system.logManagement.ipAddress')"/>
          <el-table-column prop="clientInfo" :label="$t('system.logManagement.clientInfo')" />
        </Table>
      </el-tab-pane>
      <el-tab-pane class="tab-pane" :label="$t('system.logManagement.operationLog')" name="operateLog">
        <Table ref="detailRef" :params="detail.params" :request="getOperateLog" tooltip-effect="light">
          <!-- <template #search="{query}">
            <el-form-item>
              <el-button type="primary" @click="exportData(query)">{{$t('points.exchange.exportTable')}}</el-button>
            </el-form-item>
          </template> -->
          <el-table-column type="index" :label="$t('pages.indexNo')" width="60px" />
          <el-table-column prop="operName" :label="$t('system.logManagement.username')" />
          <el-table-column prop="createTime" :label="$t('system.logManagement.operationTime')"/>
          <el-table-column prop="businessType" :label="$t('system.logManagement.operationType')">
            <template #default="{row}">
              <span>{{businessTypeListMap[row.businessType]}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="title" :label="$t('system.logManagement.operationModule')" />
          <el-table-column prop="operParam" :label="$t('system.logManagement.operationContent')" >
            <template #default="{row}">
              <el-popover
                placement="top-start"
                :width="320"
                trigger="hover"
              >
                <template #default>
                  {{row.operParam}}
                </template>
                <template #reference>
                  <span style="white-space: nowrap;">{{row.operParam}}</span>
                </template>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="jsonResult" :label="$t('system.logManagement.operationalSupport')" >
            <template #default="{row}">
              <el-popover
                placement="top-start"
                :width="320"
                trigger="hover"
              >
                <template #default>
                  {{row.jsonResult}}
                </template>
                <template #reference>
                  <span style="white-space: nowrap;">{{row.jsonResult}}</span>
                </template>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="operIp" :label="$t('system.logManagement.ipAddress')" />
        </Table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { request, downloadFile } from "@/utils/request";
import { common } from "@/common/mixin";
import { reactive, toRefs } from "@vue/reactivity";
// import { ElMessage } from "element-plus";
import Table from "@/components/elp/table";
// import { formatTime } from "../../common/utils";
import { useI18n } from 'vue-i18n'
import { businessTypeList, businessTypeListMap, userList, userListMap } from "@/common/constant"

export default {
  components: {
    Table,
  },
  mixins: [common],
  setup() {
    const { t } = useI18n()
    const state = reactive({
      activeTab: 'sysLoginLog',
      statisticsRef: null,
      statistics: {
        params: [
          {
            key: "userName",
            value: "",
            label: t('system.logManagement.username'),
          },
          {
            key: "operIp",
            value: "",
            label: t('system.logManagement.ipAddress'),
          },
          {
            key: "userAction",
            type: 'Select',
            value: '',
            label: t('system.logManagement.operationType'),
            options: {
              data: userList,
              label: 'name',
              value: 'value',
            },
          },
          {
            type: "Date",
            key: "dateRange",
            value: [],
            label: t('system.logManagement.operationDate'),
            options: {
              "type": "datetimerange",
              "format": "YYYY-MM-DD HH:mm:ss",
              "value-format": "YYYY-MM-DD HH:mm:ss",
              "range-separator": t('activity.detail.to'),
              "start-placeholder": t('activity.list.startDate'),
              "end-placeholder": t('activity.list.endDate'),
              "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]
            }
          },
        ],
      },
      detailRef: null,
      detail: {
        params: [
          {
            key: "operName",
            value: "",
            label: t('system.logManagement.operator'),
          },
          {
            key: "operIp",
            value: "",
            label: t('system.logManagement.ipAddress'),
          },
          {
            key: "businessType",
            type: 'Select',
            value: '',
            label: t('system.logManagement.operationType'),
            options: {
              data: businessTypeList,
              label: 'name',
              value: 'value',
            },
          },
          {
            key: "title",
            value: '',
            label: t('system.logManagement.operationModule'),
          },
          {
          type: "Date",
          key: "dateRange",
          value: [],
          label: t('system.logManagement.operationDate'),
          options: {
            "type": "datetimerange",
            "format": "YYYY-MM-DD HH:mm:ss",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            "range-separator": t('activity.detail.to'),
            "start-placeholder": t('activity.list.startDate'),
            "end-placeholder": t('activity.list.endDate'),
            "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]
          }
        },
        ],
      },
      businessTypeListMap: businessTypeListMap,
      userListMap: userListMap
    })
    const handleTabClick = (tab, event) => {
      if(state.activeTab == 'sysLoginLog'){
        state.statisticsRef?.update()
      }else{
        state.detailRef?.update()
      }
    }
    const getStatistics = (params={}) => {
      return request("sysLoginLogList", params)
    }
    const getOperateLog = (params={}) => {
      return request("operateLogList", params)
    }

    const exportData = async (params={}) => {
      try {
        const query = { ...params }
        query.page = undefined
        query.size = undefined
        if (params.dateRange?.length) {
          query.leftTime = params.dateRange[0]
          query.rightTime = params.dateRange[1]
        } else {
          query.leftTime = undefined
          query.rightTime = undefined
        }
        const res = await downloadFile("exportRecUserList", {}, {
          method: 'GET',
          params: query
        });
        // let blob = new Blob([res],{type: "application/octet-stream"})
        let reader = new FileReader();
        reader.readAsDataURL(res);
        reader.onload = (e) => {
          const a = document.createElement('a')
          a.download = t('points.referrer.recommendationDetailsXlsx')
          a.href = e.target.result
          a.click()
        }
      } catch (error) {
        console.error(error)
      }
    }
    return {
      ...toRefs(state),
      handleTabClick,
      getStatistics,
      getOperateLog,
      exportData
    };
  },
};
</script>
<style scoped>
.section-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.list-item {
  margin-bottom: 0;
  text-align: left;
}
.tabs-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  z-index: 100;
}
:deep(.tabs-container .el-tabs__content) {
  background: #eceff4;
  flex: 1;
}

:deep(.el-tabs--border-card>.el-tabs__content) {
  padding: 0px
}

.tabs-container .tab-pane {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>